const CANVAS_SIZE = 480
const PADDING = 40

// Downloads Canvas element as a PNG
export const downloadQRasPNG = (
  name: string,
  title: string,
  elementId: string
) => {
  const oldCanvas = document.getElementById(elementId) as HTMLCanvasElement

  const newCanvas = document.createElement('canvas')
  const context = newCanvas.getContext('2d')

  newCanvas.width = CANVAS_SIZE
  newCanvas.height = CANVAS_SIZE

  // create white background and center the text
  context.font = '28px Euclid Square'
  context.fillStyle = 'white'
  context.fillRect(0, 0, CANVAS_SIZE, CANVAS_SIZE)

  // create style for text inside canvas
  context.fillStyle = '#5C6C7A'
  // copy oldCanvas to newCanvas
  context.drawImage(
    oldCanvas,
    PADDING,
    PADDING,
    CANVAS_SIZE - PADDING * 2,
    CANVAS_SIZE - PADDING * 2
  )
  context.fillText(title, PADDING, CANVAS_SIZE - 5)

  const image = newCanvas.toDataURL('image/png')
  const anchor = document.createElement('a')
  anchor.href = image
  anchor.download = `${name}-qr-code.png`
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}
